export * from './font-awesome';
export * from './font-awesome-icon-mapper';
